import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-provide-product-detail',
  templateUrl: './provide-product-detail.component.html',
  styleUrls: ['./provide-product-detail.component.scss']
})
export class ProvideProductDetailComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;
  demo = 'data';

  constructor(
    private modalService: NgbModal,
  ) { }

  @ViewChild("productDetailsModalContent") private productDetailsModalContent: ElementRef;

  @ViewChild("productDetailModal") infoPanel;

  ngOnInit() {
  }

  closeModal() {
    this.modalRef.close();
  }
  // consoleData() {
  //   return this.logService.printLog("working now...")
  // }
  open() {
    this.modalRef = this.modalService.open(this.productDetailsModalContent);
    // this.logService.printLog("Right modal opened");
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/provide-product-detail/provide-product-detail.component.ts